import ExamNotFoundModal from './ExamNotFoundModal';

export default ExamNotFoundModal;
